import { Link, useLocation } from 'react-router-dom'
import { Home, Glasses, Heart, User } from 'lucide-react'
// import { Camera } from 'lucide-react'
import { useWishlistStore } from '../../store/wishlist.store'
import { useAuthStore } from '../../store/auth.store'

export default function MobileBottomNav() {
  const { pathname } = useLocation()
  const wishlistItems = useWishlistStore((s) => s.items)
  const wishlistCount = wishlistItems?.length || 0
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated)

  // Don't render inside admin or checkout flow
  if (pathname.startsWith('/admin') || pathname === '/checkout') return null

  const navs = [
    { label: 'Home', path: '/', icon: Home, exact: true },
    { label: 'Shop', path: '/shop', icon: Glasses },
    // { label: '3D Try-On', path: '/try-on', icon: Camera, highlight: true },
    { label: 'Wishlist', path: '/wishlist', icon: Heart, badge: wishlistCount },
    { label: isAuthenticated ? 'Account' : 'Sign In', path: isAuthenticated ? '/account' : '/login', icon: User },
  ]

  return (
    <nav
      aria-label="Mobile application navigation"
      className="md:hidden fixed bottom-0 inset-x-0 z-40 bg-white/95 backdrop-blur-md border-t border-gray-200/90 shadow-[0_-4px_20px_rgba(0,0,0,0.06)] px-2 pt-1.5 pb-[max(0.5rem,env(safe-area-inset-bottom))]"
    >
      <div className="flex items-center justify-around max-w-md mx-auto">
        {navs.map((item) => {
          const isActive = item.exact ? pathname === item.path : pathname.startsWith(item.path)
          const Icon = item.icon
          return (
            <Link
              key={item.label}
              to={item.path}
              className={`relative flex flex-col items-center justify-center py-1 px-2.5 rounded-xl transition-all duration-150 active:scale-95 ${
                isActive ? 'text-[#3A8A22] font-semibold' : 'text-gray-500 hover:text-gray-900'
              }`}
            >
              <div className="relative">
                <Icon
                  className={`w-5 h-5 transition-transform duration-150 ${
                    item.highlight && !isActive ? 'text-[#3A8A22]' : ''
                  } ${isActive ? 'scale-110 stroke-[2.25]' : 'stroke-[1.75]'}`}
                />
                {!!item.badge && item.badge > 0 && (
                  <span className="absolute -top-1 -right-2 min-w-[15px] h-[15px] px-1 bg-[#5FC03F] text-black text-[9px] font-black rounded-full flex items-center justify-center leading-none">
                    {item.badge > 99 ? '99+' : item.badge}
                  </span>
                )}
              </div>
              <span className={`text-[10px] mt-1 font-montserrat tracking-tight ${isActive ? 'font-bold text-[#3A8A22]' : 'font-medium'}`}>
                {item.label}
              </span>
            </Link>
          )
        })}
      </div>
    </nav>
  )
}

